import styles from './Matterport.module.scss'

export default function Matterport(props) {
  return (
    <section className={styles.section} id="matterport">
      <h2 className={styles.title}>3D-esittely</h2>
      <iframe
        src={props.url}
        target="_blank"
        frameBorder="0"
        width="100%"
        height="500"
        scrolling="yes"
      ></iframe>
    </section>
  )
}
